<template>
    <el-container v-bind:class="{ 'isCollapseMenu': isCollapseMenu }">
        <el-dialog
            title="Смена пароля"
            :visible.sync="changeVisible"
            width="435px"
            :close-on-click-modal="false"
        >
            <div>
                <h3 class="m-b-30 color-danger" align="center">Необходимо ввести новый пароль. <br>Временный пароль действует в течение часа.</h3>
                <el-form v-model="model" ref="form" status-icon>
                    <el-form-item label="Введите новый пароль" prop="password">
                        <el-input type="password" v-model="model.password" placeholder="Пароль" />
                    </el-form-item>
                </el-form>
                <el-row :gutter="20">
                    <el-col :span="24" align="right">
                        <el-button type="primary" v-on:click="changePassword">Сменить пароль</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <backToTop></backToTop>
        <div class="header-colored"></div>
        <el-aside v-bind:class="{'active':showMenu, 'd-print-none':true, 'el-aside--closed': isMenuClosed }" width="''">
            <div class="el-aside__content">
                <el-row>
                    <el-col :xs="24" class="text-center">
                        <div class="el-aside__logo">
                            <a href="/">
                                <img src="~assets/img/logo.png" alt="" class="logo" v-if="!isCollapseMenu">
                                <img src="~assets/img/logo-vertical.png" alt="" class="logo" v-if="isCollapseMenu">
                            </a>
                        </div>
                    </el-col>
                </el-row>
                <left-side-menu :isCollapse="isCollapseMenu" @clickMenu="changeActive" :key="activeIndex"></left-side-menu>

                <div class="selected-wrapper" v-if="$mobile() && parkings">
                    <div>Выберите парковку:</div>
                    <el-select v-model="selectedParking" @change="selectParking" class="selected-parking w-100">
                        <el-option
                            v-for="item in parkings"
                            :key="item.endpoint"
                            :label="item.name"
                            :value="item.endpoint">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </el-aside>
        <el-main>
            <div class="g-wrapper">
                <el-row :gutter="20" class="d-flex align-items-center d-print-none" >
                    <span class="g-title" data-testid="pageTitle" id="header">{{ $route.meta.title }}</span>

                    <div class="user-menu m-b-20">
                        <el-dropdown class="user-menu-profile">
                            <span class="el-dropdown-link">
                                <span class="user-menu__icon" v-if="$mobile()">
                                  <i class="fa fa-user color-dark"></i>
                                </span>
                                <span class="d-none d-sm-block">Добро пожаловать,&nbsp;</span><span class="user-menu-profile__name">{{user.user.userFio}}</span>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>

                            <el-dropdown-menu slot="dropdown" class="user-menu-profile__dropdown">
                                <el-dropdown-item>
                                    <div @click="settings"><i class="icon-settings-work-tool"></i>Настройки</div>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="parkings && $loginType() === 1">
                                    <div @click="$router.push('/map')"><i class="icon-location-point"></i>Карта парковок</div>
                                </el-dropdown-item>

                                <el-dropdown-item>
                                    <div @click="logout"><i class="icon-unlock"></i>Выйти</div>
                                </el-dropdown-item>

                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="user-menu-hamburger">
                            <el-button class="ham" v-if="!$mobile()" @click="isMenuClosed = !isMenuClosed">
                                <div></div>
                            </el-button>
                        </div>
                    </div>
                </el-row>
                <el-row :gutter="20" class="g-content">
                    <el-col :span="24">
                        <router-view></router-view>
                    </el-col>
                </el-row>
            </div>
            <el-footer class="g-footer footer d-print-none" height="auto">
                <el-card shadow="never">
                    <el-row>
                        <el-col :span="12" align="left">
                            <div>© PARKTIME.PRO LLC 1997-<span>{{year}}</span></div>
                        </el-col>
                        <el-col :span="12" align="right">
                            <div class="color-info">
                                Версия: {{ version }}
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-footer>
        </el-main>
    </el-container>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import leftSideMenu from '@/components/Menu'
import backToTop from '@/components/BackToTop'

export default {
    data () {
        return {
            version: '2.2211.22.11',
            showMenu: false,
            activeIndex: '2',
            isCollapseMenu: true,
            isMenuClosed: !this.$mobile(),
            model: {
                password: ''
            },
            changeVisible: false,
            parkings: null,
            selectedParking: sessionStorage.getItem('selectedParking')
        }
    },
    components: {
        leftSideMenu,
        backToTop
    },
    computed: {
        ...mapGetters(['user']),
        year: function () {
            let date = new Date ()
            return date.getFullYear ()
        },
        isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
    },
    methods: {
        ...mapActions(['GetInfo', 'Logout']),
        changeActive () {
            this.activeIndex += this.activeIndex
            this.showMenu = false
        },
        resize () {
            this.isCollapseMenu = (window.innerWidth <= 1200 || this.$loginType() === 4)
        },
        settings () {
            this.$router.push({ name: 'settings' })
        },
        logout () {
            ['token', 'sessionId', 'companyName', 'companyId', 'username', 'loginType', 'customerId', 'contentModules', 'tarifDict', 'customerGroupDict', 'zonesDict'].map((row) => {
                sessionStorage.removeItem(row)
            })

            this.$store.dispatch('Logout')
                .then(() => {
                    this.$router.push('/login')
                })
        },
        changePassword () {
            let request = {
                Name: 'ExecuteFunction',
                ItemType: 'Customer',
                FunctionName: 'ChangePasswordNoChecking',
                FunctionParameters: [ sessionStorage.getItem('customerId'), this.model.password ]
            }

            this.$api.Auth.changePasswordNoChecking(request).then(response => {
                if (response.Result === "Success") {
                    this.$message({ message: 'Пароль сменен на новый', type: 'success', res: response })
                    sessionStorage.removeItem('loginType')
                    this.changeVisible = false
                    this.logout()
                }
                else {
                    this.$message({ message: response.ErrorString, type: 'error', res: response })
                }
            })
        },
        selectParking (val) {
            sessionStorage.setItem('selectedParking', val)
            location.reload()
        }
    },
    mounted () {
        console.log("Загрузился основной шаблон, получаем данные пользователя")

        if (this.$loginType() === 6) {
            this.logout()
        }

        let parkings = sessionStorage.getItem('parkings')
        if (parkings) {
            try {
                let parkingsJSON = JSON.parse(parkings)
                if (!this.selectedParking) {
                    this.selectedParking = parkingsJSON[0].endpoint
                }
            } catch (e) {
                sessionStorage.removeItem('config')
                this.logout()
            }
        }

        this.GetInfo().then(() => {
            if (this.$loginType() === 3 || this.$loginType() === 5) {
                this.changeVisible = true
            }

            console.log("Получили пользователя")
            Vue.prototype.$tarifDict = JSON.parse(sessionStorage.getItem('tarifDict'))
            Vue.prototype.$customerGroupDict = JSON.parse(sessionStorage.getItem('customerGroupDict'))
            Vue.prototype.$zonesDict = JSON.parse(sessionStorage.getItem('zonesDict'))
            console.log("Работает!")
        }).catch(() => {
            console.log('Get User Info Error')
            this.logout()
        })

        this.resize()
        window.onresize = () => {
            this.resize()
        }
    }
}
</script>

<style lang="scss">
    .user-menu{
        &__icon{
            color: #007AFF;
        }
    }
</style>
